import { queryClient } from "@/services/tanstackQuery/queryClient"

import { trpcOptions } from "./trpc"

// App mutations take the session from the X-Session-Id header, so sessionId comes from the caller
export async function invalidateSessionMedia(sessionId: string) {
  await Promise.all([
    queryClient.invalidateQueries(trpcOptions.app.getPhotos.queryFilter({ sessionId })),
    queryClient.invalidateQueries(trpcOptions.app.getVideos.queryFilter({ sessionId })),
    queryClient.invalidateQueries(trpcOptions.app.getSessionDetail.queryFilter({ sessionId })),
  ])
}
